export const WALLET_TYPE_FILTER_VALUES = [
  { label: "Individual", value: "INDIDVIUAL" },
  { label: "Group", value: "GROUP" },
];

export const WALLET_ACTIVE_FILTER_VALUES = [
  { label: "Active", value: true },
  { label: "Inactive", value: false },
];

export const WALLET_COMPANY_FILTER_VALUES = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export function formatWalletType(type) {
  if (type === "INDIDVIUAL") return "Individual";
  if (type === "GROUP") return "Group";
  if (!type) return "";
  return type;
}

export function isGroupWallet(walletOrType) {
  const type =
    typeof walletOrType === "string" ? walletOrType : walletOrType?.type;
  return type === "GROUP";
}

export function getWalletOwner(wallet) {
  if (!wallet) return null;
  if (wallet.user) {
    return { kind: "user", value: wallet.user };
  }
  if (wallet.userGroup) {
    return { kind: "userGroup", value: wallet.userGroup };
  }
  return null;
}

export function getWalletMemberUsers(wallet) {
  if (!wallet?.members?.length) return [];
  return wallet.members.map((member) => member.user).filter(Boolean);
}
